import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import classes from "./FarmacyRouteLayout.module.css";

const FarmacyRouteLayout = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <div className={classes.container}>
      {/* 🔹 Top Navbar */}
      <nav className={classes.navbar}>

        {/* 🔹 Hamburger button (only visible on mobile) */}
        <button className={classes.hamburger} onClick={toggleMenu}>
          <i className="fa fa-bars"></i>
        </button>

        {/* 🔹 Desktop Menu */}
        <ul className={`${classes.menu} ${menuOpen ? classes.show : ""}`}>
          <li>
            <NavLink to="/dashboard/medicines" className={({ isActive }) => (isActive ? classes.active : classes.link)} end>
              <i className="fa fa-medkit"></i> Medicines
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/getmedprescription" className={({ isActive }) => (isActive ? classes.active : classes.link)}>
              <i className="fa fa-file-text"></i> Patient Prescription
            </NavLink>
          </li>
        </ul>
      </nav>

      {/* 🔹 Main Content */}
      <main className={classes.content}>
        <Outlet />
      </main>
    </div>
  );
};

export default FarmacyRouteLayout;
